import { useQuery } from '@tanstack/react-query'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import { getCompanyInformation } from '../service/companyInformationService'
import companyInformationQueryKeys from './companyInformationQueryKeys'

export const useCompanyInformation = () => {
  const { companyId } = useContextParameters()

  return useQuery({
    queryKey: companyInformationQueryKeys.detail({ companyId }),
    queryFn: getCompanyInformation,
    enabled: !!companyId
  })
}
